import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { TextStdRg } from '@/UI/AppTypography/AppTypography';
import { AppIconButton } from '@/UI/Buttons/AppIconButton';
import { FlexCenVer } from '@/UI/styles';
import { CaretIcon } from '@/UI/Icons';
import { I18N_KEYS } from '@/language/keys';

interface NodeCarouselProps {
  isRelativePositioningCarouselFileTypes?: boolean;
  selected: number;
  steps: number;
  handleBack: () => void;
  handleNext: () => void;
}

export type NodeCarouselV2Props = Exclude<NodeCarouselProps, 'isRelativePositioningCarouselFileTypes'>;

export const NodeCarouselV2 = ({ selected, steps, handleBack, handleNext }: NodeCarouselV2Props) => {
  const { t } = useTranslation();
  const wrappedHandleBack = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      handleBack();
    },
    [handleBack],
  );

  const wrappedHandleNext = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      handleNext();
    },
    [handleNext],
  );

  if (steps < 2) {
    return null;
  }

  return (
    <FlexCenVer
      sx={{
        justifyContent: 'flex-end',
      }}
      onMouseEnter={(e) => e.stopPropagation()}
    >
      <FlexCenVer sx={{ gap: 1, pointerEvents: 'all', width: 'fit-content' }}>
        <AppIconButton
          aria-label={t(I18N_KEYS.GENERAL.ARIA.PREVIOUS_ITEM)}
          onClick={wrappedHandleBack}
          width={32}
          height={32}
          mode="on-light"
        >
          <CaretIcon style={{ height: '16px', width: '16px', transform: 'rotate(90deg)' }} />
        </AppIconButton>
        <TextStdRg color={token.text}>{`${selected + 1} / ${steps}`}</TextStdRg>
        <AppIconButton
          aria-label={t(I18N_KEYS.GENERAL.ARIA.NEXT_ITEM)}
          onClick={wrappedHandleNext}
          width={32}
          height={32}
          mode="on-light"
        >
          <CaretIcon style={{ height: '16px', width: '16px', transform: 'rotate(-90deg)' }} />
        </AppIconButton>
      </FlexCenVer>
    </FlexCenVer>
  );
};
